import { cn } from "@artprov/design-system";
import PropTypes from "prop-types";

export const ContainerCard = ({ children, className }) => {
  return (
    <div
      className={cn(
        "w-full flex justify-center flex-wrap gap-x-7 gap-y-6 mx-auto",
        className
      )}
    >
      {children}
    </div>
  );
};

ContainerCard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

